import { assertDataset, datasetSchema, type Dataset } from "@proof/core";
import type { Sheet } from "@proof/tabular";

export function datasetFromSheet(sheet: Sheet, base: Dataset): Dataset {
  if (sheet.truncated)
    throw new Error(
      "Upload exceeds the dataset row limit; split the file before importing",
    );
  if (!sheet.headers.length || sheet.headers.length > 49)
    throw new Error(
      "Upload needs 1–49 data columns (one column is reserved for row IDs)",
    );
  const columns = sheet.headers.map((label, i) => ({
    key: `column_${i + 1}`,
    label: label || `Column ${i + 1}`,
    type: "string" as const,
  }));
  const data = datasetSchema.parse({
    ...base,
    kind: "table",
    choices: [],
    columns: [{ key: "row_id", label: "Row ID", type: "string" }, ...columns],
    rows: sheet.rows.map((row, i) =>
      Object.fromEntries([
        ["row_id", String(sheet.sourceRows[i] || i + 1)],
        ...columns.map((c, j) => [c.key, row[j] ?? ""]),
      ]),
    ),
    primaryKey: "row_id",
    valueColumn: "row_id",
    labelColumn: columns[0].key,
    imageColumn: undefined,
    assetColumn: undefined,
  });
  assertDataset(data);
  return data;
}
